import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from './App.vue'
import { i18n, setLocale } from './i18n'
import './styles.css'
import './workspace.css'

setLocale(i18n.global.locale.value as 'zh-CN' | 'en')

createApp(App)
  .use(createPinia())
  .use(i18n)
  .mount('#app')
